namespace $.$$ {
	export class $shm_hitalama_skills_editor extends $.$shm_hitalama_skills_editor {
		title() { return ( this.editing() ? 'Редактирование: ' : '' ) + this.entry_title() }
		editable() { return this.entry().can_change() }
		entry_title( next?: string ) { return this.entry().title( next ) }
		identity( path: string ) { return path }
		document( next?: string ) { return this.Source( 'SKILL.md' ).value( next ) }
		header() { return this.$.$mol_error_fence( ()=> this.$.$shm_hitalama_skills_yaml.read( this.document() ).data, ()=> ({}) ) }
		skill_name( next?: string ) {
			if( next !== undefined ) { this.document( this.$.$shm_hitalama_skills_yaml.update( this.document(), next, this.description() ) ); return next }
			return String( this.header().name ?? this.entry().name() )
		}
		description( next?: string ) {
			if( next !== undefined ) { this.document( this.$.$shm_hitalama_skills_yaml.update( this.document(), this.skill_name(), next ) ); return next }
			return String( this.header().description ?? '' )
		}
		instruction( next?: string ) {
			const path = this.instruction_path()
			if( path !== 'SKILL.md' ) return this.Source( path ).value( next )
			if( next !== undefined ) { this.document( this.$.$shm_hitalama_skills_yaml.with_body( this.document(), next ) ); return next }
			return this.$.$mol_error_fence( ()=> this.$.$shm_hitalama_skills_yaml.read( this.document() ).body.replace( /^\r?\n/, '' ), ()=> this.document() )
		}
		instruction_path() {
			// Existing guides have a short manifest and one full instruction. Keep
			// their public paths intact; only present the actual document in the UI.
			const paths = this.entry().paths().filter( path => path !== 'SKILL.md' )
			if( paths.length === 1 && /\.md$/i.test( paths[0] ) && this.document().includes( '](' + paths[0] + ')' ) ) return paths[0]
			return 'SKILL.md'
		}
		name_content() { return this.editing() ? [ this.Name_input() ] : [ this.entry_title() ] }
		id_content() { return this.editing() ? [ this.Skill_name_input() ] : [ this.skill_name() ] }
		description_content() { return [ this.editing() ? this.Description_input() : this.Description_text() ] }
		instruction_content() { return [ this.editing() ? this.Instruction_input() : this.Instruction_text() ] }
		status() {
			const sources = [ ...new Set([ 'SKILL.md', this.instruction_path() ]) ].map( path => this.Source( path ) )
			const failure = sources.map( source => source.failure() ).filter( Boolean ).join( '\n' )
			if( failure ) return failure
			if( sources.some( source => source.saving() ) ) return 'Сохранение…'
			return this.$.$mol_error_fence( ()=> {
				const meta = this.$.$shm_hitalama_skills_yaml.parse( this.document() )
				if( this.$.$shm_hitalama_skills_catalog.current()?.entries().some( entry => !entry.group() && entry.link().str !== this.entry().link().str && entry.name() === meta.name ) ) return 'Этот id уже занят. Укажите уникальный id скилла.'
				return ''
			}, error => this.$.$mol_error_message( error ) )
		}
	}
}
